import { EIcons } from '../at-icon/icons';

export const atDropdownMockData = {
  hasBorder: true,
  icon: EIcons.PRICE,
  label: 'Price',
  options: [
    { label: '$100,000 – $249,999', value: '100000-249999' },
    { label: '$250,000 – $399,999', value: '250000-399999' },
    { label: '$400,000 – $549,999', value: '400000-549999' },
    { label: '$550,000 – $699,999', value: '550000-699999' },
    { label: '$700,000 – $849,999', value: '700000-849999' },
    { label: '$850,000+', value: '850000+' },
  ],
  value: '',
};
